module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 48);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = require("@jin10/utils/lib/loadScript");

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = require("@jin10/utils/lib/device");

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return wechatShareConfig; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _jin10_utils_src_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _jin10_utils_src_request__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_jin10_utils_src_request__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _jin10_utils_src_loadScript__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41);
/* harmony import */ var _jin10_utils_src_loadScript__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_jin10_utils_src_loadScript__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _jin10_utils_src_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42);
/* harmony import */ var _jin10_utils_src_device__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_jin10_utils_src_device__WEBPACK_IMPORTED_MODULE_3__);


/* global wx */



/**
 * 配置微信分享
 * @param {Object} options 选项
 * options.title 标题
 * options.desc 描述
 * options.imgUrl 封面
 * options.link 链接
 */

function wechatShareConfig(options) {
  if (!_jin10_utils_src_device__WEBPACK_IMPORTED_MODULE_3___default.a.isWeixin) {
    return false;
  }

  var jssdk = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js';
  options = _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    link: document.location.href,
    onShareSuccess: function onShareSuccess() {},
    onShareCancel: function onShareCancel() {}
  }, options);
  Promise.all([_jin10_utils_src_request__WEBPACK_IMPORTED_MODULE_1___default.a.jsonp({
    url: 'https://news-d.jin10.com/sign',
    callbackParamName: 'jsonpCallback',
    params: {
      url: location.href
    }
  }), _jin10_utils_src_loadScript__WEBPACK_IMPORTED_MODULE_2___default()(jssdk)]).then(function (_ref) {
    var data = _ref[0].data;
    wx.config({
      debug: false,
      appId: 'wx4cbb30b2fd83dd88',
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
    });
    wx.ready(function () {
      wx.onMenuShareTimeline({
        title: options.title,
        // 分享标题
        link: options.link,
        // 分享链接
        imgUrl: options.imgUrl,
        // 分享图标
        success: function success() {
          // 用户确认分享后执行的回调函数
          options.onShareSuccess('timeline');
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
          options.onShareCancel();
        }
      });
      wx.onMenuShareAppMessage({
        title: options.title,
        // 分享标题
        desc: options.desc,
        // 分享描述
        link: options.link,
        // 分享链接
        imgUrl: options.imgUrl,
        // 分享图标
        type: 'link',
        // 分享类型,music、video或link，不填默认为link
        dataUrl: '',
        // 如果type是music或video，则要提供数据链接，默认为空
        success: function success() {
          // 用户确认分享后执行的回调函数
          options.onShareSuccess('appMessage');
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
          options.onShareCancel();
        }
      });
      wx.onMenuShareQQ({
        title: options.title,
        desc: options.desc,
        link: options.link,
        imgUrl: options.imgUrl,
        success: function success() {
          // 用户确认分享后执行的回调函数
          options.onShareSuccess('qq');
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
          options.onShareCancel();
        }
      });
    });
  });
}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@jin10/utils/lib/request");

/***/ })

/******/ });